import axios from "axios"
import { useEffect, useState } from "react"
import { BRANCHES_API, ORGANIZATIONS_API, BASE_URL } from "../../../../Utilities/APIs"

function ViewBranch({targetID, employee}) {

    const [branch, setBranch] = useState(null)
    console.log(typeof branch?.organization)
    const [organization, setOrganization] = useState(null)
    // console.log(organization)

    useEffect(() => {
  
      async function fetchAndSetBranch() {
      
          const {data} = await axios.get(BRANCHES_API + targetID)

          setBranch(data);
      }
  
      fetchAndSetBranch()
      
    }, [targetID, employee.token])

    useEffect(() => {

        if (branch) {

            async function fetchAndSetOrganization() {
      
                const {data} = await axios.get(ORGANIZATIONS_API + branch.organization)
      
                setOrganization(data);
            }
        
            fetchAndSetOrganization()
        }

    }, [branch])
    
    return (
        <div className="crud_view_content">

            {branch &&
            <>
            <h1>Name</h1>
            <p>{branch.name}</p>

            <h1>Organization</h1>
            <p>{organization?.name}</p>

            <h1>Map Location</h1>
            <p>{branch.mapLocation}</p>

            <h1>Phone Number</h1>
            <p>{branch.branchPhoneNumber}</p>

            <h1>Address</h1>
            <p>{branch.branchAddress}</p>

            <h1>Image</h1>
            <img src={BASE_URL + branch.image.slice(6, branch.image.length)} alt={branch.name} />
            </>
            }
        </div>
    )
}

export default ViewBranch